import React, { useState } from "react";
import Project from "./project";
import INFO from "../../data/user";
import "./styles/allProjects.css";

const FILTERS = ["All", "Web", "Mobile", "Shopify", "AI"];

const AllProjects = () => {
	const [active, setActive] = useState("All");

	const filtered = active === "All"
		? INFO.projects
		: INFO.projects.filter((p) => p.category === active);

	return (
		<div>
			<div className="projects-filter-bar">
				{FILTERS.map((f) => (
					<button
						key={f}
						className={`filter-btn ${active === f ? "filter-btn-active" : ""}`}
						onClick={() => setActive(f)}
					>
						{f}
						<span className="filter-count">
							{f === "All" ? INFO.projects.length : INFO.projects.filter((p) => p.category === f).length}
						</span>
					</button>
				))}
			</div>

			<div className="all-projects-container">
				{filtered.map((project, index) => (
					<div className="all-projects-project" key={index}>
						<Project
							logo={project.logo}
							title={project.title}
							description={project.description}
							linkText={project.linkText}
							link={project.link}
							linkAndroid={project.linkAndroid}
							linkIOS={project.linkIOS}
							image={project.image}
							imageAndroid={project.imageAndroid}
							tags={project.tags}
							category={project.category}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default AllProjects;
